export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--U.357c4418.png";